import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';
import { Edit as EditIcon, VisibilityOutlined as ViewIcon } from '@mui/icons-material';
const Root = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    justifySelf: 'flex-end',
    '& > button:first-of-type:not(:only-child)': {
        marginRight: theme.spacing(2),
    },
}));
const Actions = ({ actions, handleView, handleEdit }) => {
    return (_jsxs(Root, { children: [actions.map((action) => (_jsx(Button, Object.assign({ variant: "outlined", color: "primary", startIcon: action.icon, onClick: action.onClick }, { children: action.label })))), handleView && (_jsx(Button, Object.assign({ variant: "outlined", color: "primary", startIcon: _jsx(ViewIcon, {}), onClick: handleView }, { children: "View" }))), handleEdit && (_jsx(Button, Object.assign({ variant: "outlined", color: "primary", startIcon: _jsx(EditIcon, {}), onClick: handleEdit }, { children: "Edit" })))] }));
};
export default Actions;
//# sourceMappingURL=actions.js.map